import { render } from "./IconCard.vue?vue&type=template&id=0a2e367f&scoped=true"
import script from "./IconCard.vue?vue&type=script&lang=js"
export * from "./IconCard.vue?vue&type=script&lang=js"

import "./IconCard.vue?vue&type=style&index=0&id=0a2e367f&lang=scss&scoped=true"

import exportComponent from "D:\\project\\php\\quickadmin\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2e367f"]])

export default __exports__